import React, { useCallback, useEffect, useState } from 'react'
import { Outlet, useSearchParams } from 'react-router-dom'
import { Box, useTheme } from '@mui/material'

import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import AuditPageHeader from '../../components/audit/AuditPageHeader'
import { getCountString, Icons } from '../../utils/utilities'
import api from '../../service/api'

const AuditAssignments = () => {

    const [searchParams] = useSearchParams( { searchText: "", month: "", selectedDepartment: "all", selectedInstitute: "all", view: "tabular", sortByName: "1", sortBySubmissionsCount: "1", sortByAssignmentCount: "1" } )
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"
    const selectedDepartment = searchParams.get( 'selectedDepartment' ) || "all"

    const [error, setError] = useState( false )
    const [counts, setCounts] = useState( {} )
    const [loading, setLoading] = useState( true )

    const { layout } = useTheme()

    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const department = selectedDepartment !== "all" ? selectedDepartment : ""
            const institute = selectedInstitute !== "all" ? selectedInstitute : ""
            const { data: { data: counts } } = await api.audit.getAssignmentCounts( { last30dayscount: true, institute, department } )
            setCounts( counts )
            setError( null )
        } catch ( err ) {
            setError( { code: err?.response?.status, message: err?.response?.data?.message || "Something went wrong while fetching the assignment audit data." } )
        } finally {
            setLoading( false )
        }
    }, [selectedInstitute, selectedDepartment] )


    useEffect( () => {
        getData()
    }, [getData] )



    return (
        <Box padding={layout.pagePadding} display="flex" flexDirection="column" gap={layout.sectionsGap} overflow="auto" flexGrow={1}>

            {/* Header */}
            <AuditPageHeader
                loading={loading}
                title="Assignments audit"
                subtitle="View all assignment activities here."
                countCards={[
                    {
                        icon: Icons.default.AssignmentIcon,
                        label: "Assignments",
                        value: getCountString( counts.totalAssignmentCount ),
                        secondary: getCountString( counts.last30daysCount ),
                        secondaryLabel: "In last 30 days"
                    },
                    {
                        icon: Icons.default.UploadFileIcon,
                        label: "Submissions",
                        value: getCountString( counts.totalSubmissionCount ),
                        secondary: getCountString( counts.last30daySubmissionCount ),
                        secondaryLabel: "In last 30 days"
                    },
                ]}
            />

            {error && <Box sx={{ padding: "20px" }}>
                <TryAgainMessageBlock getData={() => { }} err={error.message} code={error.code} loading={loading} />
            </Box>}
            <Outlet />
        </Box >
    )
}

export default AuditAssignments
